import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { ModalPopupService } from '@app/shared/services/modal-popup.service';
import { UtilService } from '@app/core/util.service';
import { NotificationService } from '@app/shared/services/notification.service';
/**
 * Simple table component with inline editing
 * Paginations not supported
 */
@Component({
  selector: 'app-vs-table-edit',
  templateUrl: './vs-table-edit.component.html',
  styleUrls: ['./vs-table-edit.component.scss']
})
export class VsTableEditComponent implements OnInit {
  items: any = [];

  @Input() tableConfig: any;

  backupData = {};

  constructor(
    private http: HttpClient,
    private modal: ModalPopupService,
    private util: UtilService,
    private notify: NotificationService
  ) { }

  onRowEditInit(item: any) {
    if (item.sid) {
      this.backupData[item.sid] = { ...item };
    } else if (item.data && item.data.sid) {
      this.backupData[item.data.sid] = { ...item.data };
    }
  }

  onRowEditSave(item: any) {
    if (item.sid) {

      if (this.util.isEqualIgnoreCase(item, this.backupData[item.sid], null, null)) {
        return;
      }
      if (!this.isValidData(item)) {
        return;
      }
      delete this.backupData[item.sid];
      this.updateData(item);
    } else {
      if (!this.isValidData(item)) {
        return;
      }
      this.saveData(item)
    }
  }

  onRowEditCancel(item: any, index: number) {
  }

  handleEditComplete(event: any) {
    this.onRowEditSave(event.data);
  }

  onRowDelete(item: any) {
    this.modal.openConfirmationModal('Confirm ?', 'Are you sure you want to delete this record', null, null, null).subscribe(d => {
      this.deleteData(item);
    });
  }

  getVal(data: any, field: any, type?: any) {
    return data[field] ? data[field] : '';
  }

  addRow() {
    this.items.push({});
  }

  setInitialValue() {
    const cols = this.tableConfig.columns || [];
    const colData = [];
    Object.keys(cols).map(c => {
      colData.push({ [c]: null });
    });
    this.items.push(colData);
  }

  setData(data: any[]) {
    this.items = data;
  }

  getData() {
    if (this.tableConfig.getUrl) {
      this.http.get(this.tableConfig.getUrl).subscribe((d: any) => {
        console.log('data : ', d);
        this.setData(d.results);
      }, err => {
        console.log('err : ', err);
      });
    }
  }

  saveData(item: any) {
    if (this.tableConfig.saveUrl) {
      this.http.post(this.tableConfig.saveUrl, item).subscribe(d => {
        console.log(d);
      }, err => {
        console.log(err);
      });
    }
  }

  //TODO
  updateData(item: any) {
    if (this.tableConfig.updateUrl) {
      this.http.put(this.tableConfig.updateUrl, item).subscribe(d => {
        console.log(d);
        this.items = this.items.map(i => {
          if (i.sid == item.sid) {
            i = item;
          }
          return i;
        });
      }, err => {
        console.log(err);
        this.items = this.items.map(i => {
          if (i.sid == item.sid) {
            i = item;
          }
          return i;
        });
      });
    }
  }

  //TODO
  deleteData(item: any) {
    if (this.tableConfig.deleteUrl) {
      this.http.delete(this.tableConfig.deleteUrl, item.sid).subscribe(d => {
        console.log(d);
        this.removeDeletedRecord(item);
      }, err => {
        console.log(err);
        this.removeDeletedRecord(item);
      });
    }
  }

  removeDeletedRecord(item) {
    this.items = this.items.filter(i => i.sid != item.sid);
  }

  isValidData(item) {
    let errors = [];
    const cols = this.tableConfig.columns;
    cols.map(col => {
      if (col.validations) {
        if (col.validations.required && !item[col.name]) {
          errors.push(`${col.label} is mandatory. `)
        }
      }
      return col;
    });

    if (errors.length) {
      this.notify.error(errors.join(','));
      return false;
    }
    return true;
  }
  ngOnInit() {
    this.setInitialValue();
    this.getData();
  }
}
